import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography, useTheme} from "@mui/material";
import {useTranslation} from "react-i18next";
import '../../../style/SalesMarketing.css';
import * as React from "react";
import Box from "@mui/material/Box";
import CheckCircleRounded from '@mui/icons-material/CheckCircleRounded';
import {useNavigate} from "react-router-dom";

interface LeisureAgreementCreationModalProps {
    open: boolean,
    isUpdate: boolean,
    handleCloseCreationModal: Function,
    leisureCode: string
}

const LeisureAgreementCreationModal = ({
                                open,
                                isUpdate,
                                handleCloseCreationModal,
                                leisureCode
                            }: LeisureAgreementCreationModalProps) => {
    const {t} = useTranslation(['salesmarketing']);
    const navigate = useNavigate();
    const theme = useTheme();

    return (
        <Dialog disableEscapeKeyDown fullWidth={true} open={open}
                onClose={() => {
                    return;
                }}>
            <DialogTitle>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                    <CheckCircleRounded color={"success"}/>
                    <Typography sx={{paddingLeft: "10px"}} fontWeight={"bold"} color={"primary"}>
                        {isUpdate ? t('salesmarketing:leisureAgreement.updateForm.modalTitleSuccess') : t('salesmarketing:leisureAgreement.createForm.modalTitleSuccess')}
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2} sx={{padding: "15px"}} alignItems={"center"}>
                    <Grid item>
                        <Typography color={"primary"} variant={"body1"} style={{whiteSpace: "pre-line"}}>
                            {isUpdate ? t('salesmarketing:leisureAgreement.updateForm.modalDescriptionSuccess') : t('salesmarketing:leisureAgreement.createForm.modalDescriptionSuccess', {leisureCode: leisureCode})}
                        </Typography>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{backgroundColor: theme.palette.neutral.bright, padding: "15px"}}>
                <Button color={"accent"} onClick={() => {
                    handleCloseCreationModal();
                    navigate("/salesmarketing/leisureagreementlist");
                }}>{t('salesmarketing:leisureAgreement.buttons.close')}</Button>
            </DialogActions>
        </Dialog>
    );
}

export default LeisureAgreementCreationModal;